import { combineEpics, ofType } from "redux-observable";
import { of, from, Observable, mergeMap, catchError } from "rxjs";
import { AnyAction } from "redux";
import { RootStateOrAny } from "react-redux";

import {
  fetchComments,
  fetchCommentSuccess,
  fetchCommentFailure,
  updateCommentSuccess,
  updateCommentFailure,
} from "./actions";

import {
  fetchCommentUsecase,
  updateCommentUsecase,
} from "../../core/usecases/interactors/comment";

import { FETCH_COMMENT_REQUEST, UPDATE_COMMENT_REQUEST } from "./actionType";

import { errorString } from "../../utils/strings";
import { data as constants } from "../../constants";

export const fetchCommentEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    commentInteractor: { fetchComment },
  }: { commentInteractor: { fetchComment: fetchCommentUsecase } }
): Observable<
  | ReturnType<typeof fetchCommentSuccess>
  | ReturnType<typeof fetchCommentFailure>
> =>
  action$.pipe(
    ofType(FETCH_COMMENT_REQUEST),
    mergeMap(({ payload: { applicantId } }) => {
      return from(fetchComment(applicantId)).pipe(
        mergeMap((response) => {
          return of(fetchCommentSuccess(response));
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          errorString(error).includes(constants.commonNetworkError) &&
            window.location.reload();
          return of(fetchCommentFailure(errorMessage));
        })
      );
    })
  );

export const updateCommentEpic = (
  action$: Observable<AnyAction>,
  _state$: RootStateOrAny,
  {
    commentInteractor: { updateComment },
  }: { commentInteractor: { updateComment: updateCommentUsecase } }
) =>
  action$.pipe(
    ofType(UPDATE_COMMENT_REQUEST),
    mergeMap(({ payload: { applicantId, id, data } }) => {
      return from(updateComment(applicantId, id, data)).pipe(
        mergeMap(() => {
          return of(fetchComments(applicantId), updateCommentSuccess());
        }),
        catchError((error) => {
          const errorMessage = errorString(error);
          errorString(error).includes(constants.commonNetworkError) &&
            window.location.reload();
          return of(updateCommentFailure(errorMessage));
        })
      );
    })
  );

// @ts-ignore
export default combineEpics(fetchCommentEpic, updateCommentEpic);
